export default __webpack_public_path__ + "static/alert-f95fa50ad9ffd8e291ce56241e63eda3.mp3";